export const ConvertToSentenceCase = (stringValue) => {

    if (!stringValue) return stringValue;

    stringValue = stringValue.trim().toLowerCase();

    return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
};
